import {
  cssFluidSize,
} from "./styleHelpers";


type Spacing = {
  xxxs: string
  xxs: string
  xs: string
  sm: string
  md: string
  lg: string
  xl: string
  xxl: string
  xxxl: string
}

const spacing: Spacing = {
  xxxs:  cssFluidSize([8,   12]),
  xxs:   cssFluidSize([12,  16]),
  xs:    cssFluidSize([18,  24]),
  sm:    cssFluidSize([24,  32]),
  md:    cssFluidSize([30,  40]),
  lg:    cssFluidSize([44,  60]),
  xl:    cssFluidSize([56,  78]),
  xxl:   cssFluidSize([76,  132]),
  xxxl:  cssFluidSize([100, 200]),
} as const;

export type SpacingKey = keyof Spacing
export const spacingKeys = Object.keys(spacing) as SpacingKey[]

export const space = (key: SpacingKey): string => {
  return spacing[key]
}

// export const applySpacing = (baseTheme: Theme) => {
//   baseTheme.spacing = deepmerge(baseTheme.spacing, theme.spacing)
//   return baseTheme;
// }


export default spacing